import { render, staticRenderFns } from "./Workshops.vue?vue&type=template&id=5e06560a"
import script from "./Workshops.vue?vue&type=script&lang=js"
export * from "./Workshops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports